import styles from "./styles.module.scss";
import Travel from "./travel";
import Buildings from "./buildings";
import Books from "./books";
import Market from "./market";
import Bank from "./bank";
import img4 from "../../images/4.png";
import Section from "../../components/Section";

const Web = () => {
  return (
    <div className={styles.container}>
      <Section display>
        <div className={styles.title}>
          <div>
            <img src={img4} alt="4" />
          </div>
          <h1>ВЕБ-ДИЗАЙН</h1>
        </div>
      </Section>
      <div className={styles.content}>
        <Travel />
        <Buildings />
        <Books />
        <Market />
        <Bank />
      </div>
    </div>
  );
};

export default Web;
